<template>
  <section
    class="relative bg-[url('/assets/images/stats-background.webp')] bg-cover bg-center py-20 px-6 md:px-10 lg:px-40 min-h-[250px] w-full"
  >
    <div class="absolute inset-0 bg-black/60 backdrop-blur-sm rounded-lg z-0" />
    <div
      class="relative z-10 flex flex-col md:flex-row justify-center items-center gap-10 text-white"
    >
      <!-- Öğrenci -->
      <div class="text-center">
        <p
          class="text-[48px] md:text-[56px] lg:text-[64px] font-bold tracking-tight"
        >
          +{{ stats.students }}
        </p>
        <span class="text-xl md:text-2xl text-white/80">
          {{ t("stats.students") }}
        </span>
      </div>

      <!-- Modül -->
      <div class="text-center">
        <p
          class="text-[48px] md:text-[56px] lg:text-[64px] font-bold tracking-tight"
        >
          +{{ stats.modules }}
        </p>
        <span class="text-xl md:text-2xl text-white/80">
          {{ t("stats.modules") }}
        </span>
      </div>

      <!-- Teknik Video -->
      <div class="text-center">
        <p
          class="text-[48px] md:text-[56px] lg:text-[64px] font-bold tracking-tight"
        >
          +{{ stats.videos }}
        </p>
        <span class="text-xl md:text-2xl text-white/80">
          {{ t("stats.videos") }}
        </span>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useSupabaseClient, useI18n } from "#imports";

const { t } = useI18n();
const supabase = useSupabaseClient();
const stats = ref({
  students: 2,
  modules: 4,
  videos: 0,
});

onMounted(async () => {
  try {
    // Benzersiz öğrenci sayısı
    const { data: studentData } = await supabase
      .from("subscriptions")
      .select("user_id", { count: "exact", head: false });

    const uniqueStudents = new Set(studentData?.map((s) => s.user_id)).size;

    // Toplam modül sayısı
    const { count: moduleCount } = await supabase
      .from("moduls")
      .select("id", { count: "exact", head: true })
      .eq("status", true);

    // Toplam teknik video (block_course) sayısı
    const { count: videoCount } = await supabase
      .from("block_course")
      .select("id", { count: "exact", head: true })
      .eq("status", true);

    stats.value = {
      students: uniqueStudents || 2,
      modules: moduleCount || 4,
      videos: videoCount || 0,
    };
  } catch (error) {
    console.error("İstatistik verileri alınamadı:", error);
  }
});
</script>

<style scoped></style>
